import type { CirclesChart } from '../circlesChart.js';
import type { CirclesVariant } from '../gameTypes.js';
import { PALETTE_CRIMSON } from '../builtinPulseMaps/palettes.js';
import { assembleImportedCirclesChart } from './importedOsuChart.js';
import audioOnsets from './audio/my-heart.onsets.json' with { type: 'json' };
import normalImported from './imported/my-heart-normal.circles.json' with { type: 'json' };
import hardImported from './imported/my-heart-hard.circles.json' with { type: 'json' };
import extremeImported from './imported/my-heart-extreme.circles.json' with { type: 'json' };

export const MY_HEART_CIRCLES_VARIANTS: Record<CirclesVariant, CirclesChart> = assembleImportedCirclesChart({
  baseSlug: 'my-heart',
  baseTitle: "My Heart",
  description: "Different Heaven & EH!DE's heavy electro at 174 BPM. Fast, dense, demanding.",
  difficulty: 4,
  palette: PALETTE_CRIMSON,
  audioSrc: '/audio/circles/my-heart.mp3',
  attribution: "\"My Heart\" by Different Heaven & EH!DE [NCS Release] - https://ncs.io/MyHeart",
  mapper: "Aleycks & Sgord1",
  anchorOnsets: audioOnsets,
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
  timing: {
    normal: { bpm: 87, offsetMs: 0, totalBeats: 90 },
    hard: { bpm: 87, offsetMs: 0, totalBeats: 90 },
    extreme: { bpm: 87, offsetMs: 0, totalBeats: 90 },
  },
});
